import { combineReducers } from 'redux';
import {
  SETTING_BANK_ACCOUNT_SET_BANK_LIST,
  SETTING_BANK_ACCOUNT_SET_OUTLETS,
  SETTING_BANK_ACCOUNT_SET_OUTLET_STATUS,
  SETTING_BANK_ACCOUNT_SET_BANK_ACCOUNT_LISTS,
  SETTING_BANK_ACCOUNT_SET_BANK_ACCOUNT_DETAIL,
  SETTING_BANK_ACCOUNT_SET_UNLINK_OUTLETS,
  SETTING_BANK_ACCOUNT_SET_PAYMENT_METHODS,
  SETTING_BANK_ACCOUNT_SET_ERRORS,
  SETTING_BANK_ACCOUNT_SET_AVAILABLE_OUTLETS,
  SETTING_BANK_ACCOUNT_SET_PROFILE,
  SETTING_BANK_ACCOUNT_SET_OTP,
  SETTING_BANK_ACCOUNT_SET_ACTIVITY_LOGS,
  SETTING_BANK_ACCOUNT_SET_SELECTED_ACTIVITY_LOG,
  SETTING_BANK_ACCOUNT_SET_SEARCH_BANK_ACCOUNTS,
  SETTING_BANK_ACCOUNT_SET_HAS_MORE_ACTIVITY_LOGS,
  SETTING_BANK_ACCOUNT_ADD_ASSIGN_OUTLET_MODAL,
  SETTING_BANK_ACCOUNT_SHOW_LOADING_SPINNER_MODAL,
  SETTING_BANK_ACCOUNT_HIDE_LOADING_SPINNER_MODAL,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_ASSIGN_OUTLETS,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_ASSIGN_OUTLETS,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_SAVE_ALL,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_SAVE_ALL,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_CHANGES,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_CHANGES,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_ASSIGN_OUTLETS,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_ASSIGN_OUTLETS,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_DELETE,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_DELETE,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_VERIFY_PHONE,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_VERIFY_PHONE,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_VERIFY_OTP,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_VERIFY_OTP,
  SETTING_BANK_ACCOUNT_SHOW_RIGHT_COLUMN,
  SETTING_BANK_ACCOUNT_HIDE_RIGHT_COLUMN,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_ACTIVITY_LOG,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_ACTIVITY_LOG,
  SETTING_BANK_ACCOUNT_SHOW_ACTIVITY_LOG_DETAIL,
  SETTING_BANK_ACCOUNT_HIDE_ACTIVITY_LOG_DETAIL,
} from 'actions/setting/bankAccount/constants';

import createReducer from 'utils/createReducer';

const activityLogs = createReducer([], {
  [SETTING_BANK_ACCOUNT_SET_ACTIVITY_LOGS]: (draft, { payload }) =>
    payload.activityLogs,
});

const availableOutlets = createReducer([], {
  [SETTING_BANK_ACCOUNT_SET_AVAILABLE_OUTLETS]: (draft, { payload }) =>
    payload.availableOutlets,
});

const bankAccountDetail = createReducer(null, {
  [SETTING_BANK_ACCOUNT_SET_BANK_ACCOUNT_DETAIL]: (draft, { payload }) =>
    payload.bankAccount,
});

const bankAccountLists = createReducer([], {
  [SETTING_BANK_ACCOUNT_SET_BANK_ACCOUNT_LISTS]: (draft, { payload }) =>
    payload.bankAccountLists,
});

const bankList = createReducer([], {
  [SETTING_BANK_ACCOUNT_SET_BANK_LIST]: (draft, { payload }) =>
    payload.bankList,
});

const errors = createReducer(
  {},
  {
    [SETTING_BANK_ACCOUNT_SET_ERRORS]: (draft, { payload }) => payload.errors,
  }
);

const hasMoreActivityLogs = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SET_HAS_MORE_ACTIVITY_LOGS]: (draft, { payload }) =>
    payload.hasMoreActivityLogs,
});

const openAssignOutletModal = createReducer(false, {});

const openRightColumn = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SHOW_RIGHT_COLUMN]: () => true,
  [SETTING_BANK_ACCOUNT_HIDE_RIGHT_COLUMN]: () => false,
});

const otp = createReducer(
  {},
  {
    [SETTING_BANK_ACCOUNT_SET_OTP]: (draft, { payload }) => payload.otp,
  }
);

const outlets = createReducer([], {
  [SETTING_BANK_ACCOUNT_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const outletStatus = createReducer([], {
  [SETTING_BANK_ACCOUNT_SET_OUTLET_STATUS]: (draft, { payload }) =>
    payload.outletStatus,
});

const paymentMethods = createReducer([], {
  [SETTING_BANK_ACCOUNT_SET_PAYMENT_METHODS]: (draft, { payload }) =>
    payload.paymentMethods,
});

const profile = createReducer(null, {
  [SETTING_BANK_ACCOUNT_SET_PROFILE]: (draft, { payload }) => payload.profile,
});

const rightColumnType = createReducer('', {
  [SETTING_BANK_ACCOUNT_SHOW_RIGHT_COLUMN]: (draft, { payload }) =>
    payload.rightColumnType,
});

const searchBankAccounts = createReducer([], {
  [SETTING_BANK_ACCOUNT_SET_SEARCH_BANK_ACCOUNTS]: (draft, { payload }) =>
    payload.bankAccounts,
});

const selectedActivityLog = createReducer(null, {
  [SETTING_BANK_ACCOUNT_SET_SELECTED_ACTIVITY_LOG]: (draft, { payload }) =>
    payload.activityLog,
});

const selectedOutlets = createReducer([], {
  [SETTING_BANK_ACCOUNT_ADD_ASSIGN_OUTLET_MODAL]: (draft, { payload }) =>
    payload.outletList,
});

const showActivityLogDetail = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SHOW_ACTIVITY_LOG_DETAIL]: () => true,
  [SETTING_BANK_ACCOUNT_HIDE_ACTIVITY_LOG_DETAIL]: () => false,
});

const showLoadingSpinnerModal = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SHOW_LOADING_SPINNER_MODAL]: () => true,
  [SETTING_BANK_ACCOUNT_HIDE_LOADING_SPINNER_MODAL]: () => false,
});

const showModalActivityLog = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SHOW_MODAL_ACTIVITY_LOG]: () => true,
  [SETTING_BANK_ACCOUNT_HIDE_MODAL_ACTIVITY_LOG]: () => false,
});

const showModalAssignOutlets = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SHOW_MODAL_ASSIGN_OUTLETS]: () => true,
  [SETTING_BANK_ACCOUNT_HIDE_MODAL_ASSIGN_OUTLETS]: () => false,
});

const showModalConfirmChanges = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_CHANGES]: () => true,
  [SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_CHANGES]: () => false,
});

const showModalConfirmSaveAll = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_SAVE_ALL]: () => true,
  [SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_SAVE_ALL]: () => false,
});

const showModalConfirmAssignOutlets = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_ASSIGN_OUTLETS]: () => true,
  [SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_ASSIGN_OUTLETS]: () => false,
});

const showModalDelete = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SHOW_MODAL_DELETE]: () => true,
  [SETTING_BANK_ACCOUNT_HIDE_MODAL_DELETE]: () => false,
});

const showModalVerifyPhone = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SHOW_MODAL_VERIFY_PHONE]: () => true,
  [SETTING_BANK_ACCOUNT_HIDE_MODAL_VERIFY_PHONE]: () => false,
});

const showModalVerifyOtp = createReducer(false, {
  [SETTING_BANK_ACCOUNT_SHOW_MODAL_VERIFY_OTP]: () => true,
  [SETTING_BANK_ACCOUNT_HIDE_MODAL_VERIFY_OTP]: () => false,
});

const unlinkOutlets = createReducer([], {
  [SETTING_BANK_ACCOUNT_SET_UNLINK_OUTLETS]: (draft, { payload }) =>
    payload.outletList,
});

export default combineReducers({
  activityLogs,
  availableOutlets,
  bankAccountDetail,
  bankAccountLists,
  bankList,
  errors,
  hasMoreActivityLogs,
  openAssignOutletModal,
  openRightColumn,
  otp,
  outlets,
  outletStatus,
  paymentMethods,
  profile,
  rightColumnType,
  searchBankAccounts,
  selectedActivityLog,
  selectedOutlets,
  showActivityLogDetail,
  showLoadingSpinnerModal,
  showModalActivityLog,
  showModalAssignOutlets,
  showModalConfirmAssignOutlets,
  showModalConfirmChanges,
  showModalConfirmSaveAll,
  showModalDelete,
  showModalVerifyOtp,
  showModalVerifyPhone,
  unlinkOutlets,
});
